import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { RatingInputFieldWUT } from '../../../ui/rating-input-field';
export const RatingInputWUT = (props)=>{
    const fieldType = FIELD_TYPES.RATING_INPUT;
    return /*#__PURE__*/ React.createElement(RatingInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=rating-input-wut.js.map